import { render, staticRenderFns } from "./depositCard.vue?vue&type=template&id=5d680282&scoped=true"
import script from "./depositCard.vue?vue&type=script&lang=js"
export * from "./depositCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d680282",
  null
  
)

export default component.exports